import { chargingHistoryService } from "../../helpers/chargingHistoryService";

export const state = {
  getAllChargingHistory: [],
  chargingHistoryCount: "",
  getAllChargers: [],
  paginations: {},
  chargerList: [],
  loading: true,
};

export const mutations = {
  getAllChargingHistory(state, payload) {
    state.getAllChargingHistory = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.chargingHistoryCount = payload.result.total;
  },
  getAllCharger(state, payload) {
    state.getAllChargers = payload;
  },
  getChargingHistoryListRequest(state) {
    state.loading = true;
  },
  getChargingHistory(state, payload) {
    state.user = payload.result;
  },
  getChargingHistoryListFailure(state) {
    state.loading = false;
  },
    setChargerList(state, payload) {
    state.chargerList = payload;
  },
};

export const actions = {
  async getChargingHistory({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getChargingHistoryListRequest");
    await chargingHistoryService.getChargingHistory(data).then(
      (response) => {
        commit("getAllChargingHistory", response.data);
      },
      (error) => {
        commit("getChargingHistoryListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  // This helper method isnt currently being used, it will be used as mutation in the charging-history-list.vue file when we decide to fetch chargers using mutations.
async fetchChargersByUser({ commit }, userId) {
    try {
      const payload = { user_id: userId };
      const response = await chargingHistoryService.getChargers(payload);
      const formattedChargers = response.data.map(item => ({
        id: item.id,
        name: item.name,
      }));
      commit('setChargerList', formattedChargers);
    } catch (error) {
      commit('getChargingHistoryListFailure');
      throw error; // Throw error to handle in component
    }
  },
  async getCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    await chargingHistoryService.getChargers(data).then(
      (response) => {
        commit("getAllCharger", response.data);
      },
      (error) => {
        commit("getChargingHistoryListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
};
export const getters = {
  loading: (state) => state.loading,
  getAllChargers: (state) => state.getAllChargers,
  getAllChargingHistory: (state) => state.getAllChargingHistory,
  chargingHistoryCount: (state) => state.chargingHistoryCount,
  chargingHistoryData: (state) => state.getChargingHistory,
  pagination: (state) => state.paginations,
  chargerList: (state) => state.chargerList,
};
